import { Button, Tooltip } from '@cobliteam/ui/components';
import { memo } from 'react';

export interface DataTableActionProps {
  icon: any;
  tooltip?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const DataTableAction = ({ icon, tooltip, disabled, onClick }: DataTableActionProps) => {
  return (
    <div className='w-full text-center' onClick={onClick}>
      <Tooltip enable={!!tooltip} content={tooltip} delayDuration={0}>
        <Button variant='outlined' color='default' size='sm' icon={icon} disabled={disabled} data-testid='datatable-action' className='mx-auto' />
      </Tooltip>
    </div>
  );
};

export default memo(DataTableAction);
